<template>
	<v-card
		class="mx-auto"
	>
		<v-card-text>
			<v-data-table
				:items="computedItems"
				:loading="loading"
				:sort-by="[{key: 'date', localOrder: 'desc'}]"
				:items-per-page="10"
				:headers="tableHeaders"
			>
				<template #item.productName="{ item }">
					<a
						:href="`/bo/products/view?id=${item.productId}`"
					>
						{{ item.productName }}
					</a>
				</template>
				<template #item.productversionId="{ item }">
					<a
						:href="`/bo/products/view?id=${item.productId}&productversion=${item.productversionId}`"
					>
						{{ item.productversionId }}
					</a>
				</template>
				<template #item.comment="{ item }">
					<v-tooltip
						v-if="item.comment !== null"
						location="bottom"
					>
						<template #activator="{ props }">
							<v-icon
								v-bind="props"
								icon="$infoOutline"
							/>
						</template>
						{{ item.comment }}
					</v-tooltip>
				</template>
			</v-data-table>
		</v-card-text>
	</v-card>
</template>

<script>
import {
	axios,
} from '../../services/axios-service';

export default {
	name: 'PricingParameterTable',

	props: {
		productVersion: {
			type: Number,
			required: false,
			default: 0
		},

		verbose: {
			type: Boolean,
			required: false,
			default: false
		}
	},

	emits: ['items-retrieved',],

	data () {
		return {
			endpoint: '/bo/pricing/parameters/index',
			items: [],
			loading: true,
		};
	},

	computed: {

		/**
		 * If there was a product version id applied then only show the relevant parameters
		 *
		 * @returns {Array}
		 */
		computedItems () {
			return this.items.filter((item) => {
				if (this.productVersion) {
					return item.productversionId === this.productVersion;
				}
				return true;
			});
		},

		/**
		 * @returns {Array} table headers
		 */
		tableHeaders () {
			const headers = this.verbose ? [
				{
					title: this.$gettext('Domain'), value: 'domain',
				},
				{
					title: this.$gettext('Product'), value: 'productName',
				},
				{
					title: this.$gettext('Product Version'), value: 'productversionId',
				},
			] : [];

			return headers.concat([
				{
					title: 'Alpha', value: 'alpha',
				},
				{
					title: 'Beta', value: 'beta',
				},
				{
					title: 'Sigma', value: 'sigma',
				},
				{
					title: this.$gettext('Comment'), value: 'comment',
				},
				{
					title: this.$gettext('User'), value: 'user',
				},
				{
					title: this.$gettext('Change Date'), value: 'date',
				},
			]);
		},
	},

	mounted () {
		this.index();
	},

	methods: {
		/**
		 * Update table
		 */
		update () {
			this.index();
		},

		/**
		 * Retrieves data for table from endpoint
		 *
		 * @returns {void}
		 */
		index () {
			this.loading = true;
			axios.get(this.endpoint).then(({
				data
			}) => {
				this.items = data.items ? data.items : data;
				this.$emit('items-retrieved', this.items);
				this.loading = false;
			}).catch((error) => {
				window.captureException(error);
				this.loading = false;
			});
		},
	}
};
</script>

<style scoped>

</style>
